import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=5afc46a3&scoped=true&"
import script from "./produce.vue?vue&type=script&lang=js&"
export * from "./produce.vue?vue&type=script&lang=js&"
import style0 from "./produce.vue?vue&type=style&index=0&id=5afc46a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc46a3",
  null
  
)

export default component.exports